"use client";

import posthog from "posthog-js";
import { useFeatureFlagEnabled } from "posthog-js/react";
import { useEffect } from "react";

export function usePostHogFlag(flag: string) {
  const flagEnabled = useFeatureFlagEnabled(flag);

  useEffect(() => {
    if (flagEnabled) {
      // Pre-compute the dynamic property key
      const featureInteractionKey = `$feature_interaction/${flag}`;

      // Create the $set object separately to avoid computed property in object literal
      const setObject: Record<string, boolean> = {};
      setObject[featureInteractionKey] = true;

      posthog.capture("$feature_interaction", {
        $set: setObject,
        feature_flag: flag,
      });
    }
  }, [flagEnabled, flag]);

  return flagEnabled;
}
